import { ArrowsClockwiseIcon, CheckCircleIcon, PencilSimpleIcon } from '@phosphor-icons/react'

import { ContactCarrierIcon, ContactCustomerIcon, shipmentStatuses } from '@reveni-io/reveni-ui'

import { availableActions, availableExceptions } from './constants'

export const findException = alert => availableExceptions?.find(exception => exception.code === alert?.type)

export const getDateByStatus = ({ status, createdAt, packedAt, readyAt, shippedAt, outForDeliveryAt, deliveredAt }) => {
  let dateToShow = null

  if (status === shipmentStatuses.requested) {
    dateToShow = new Date(createdAt)
  }

  if (status === shipmentStatuses.packed) {
    dateToShow = new Date(packedAt)
  }

  if (status === shipmentStatuses.ready) {
    dateToShow = new Date(readyAt)
  }

  if (status === shipmentStatuses.shipped) {
    dateToShow = new Date(shippedAt)
  }

  if (status === shipmentStatuses.out_for_delivery) {
    dateToShow = new Date(outForDeliveryAt)
  }

  if (status === shipmentStatuses.delivered) {
    dateToShow = new Date(deliveredAt)
  }

  return dateToShow
}

export const getAlertActions = ({
  exception,
  t,
  onGenerateLabel,
  generatingLabel,
  openEditOutboundDestinationAddressModal,
  openSendEmailModalForContactCustomer,
  openSendEmailModalForContactCarrier,
  markParcelAlertAsRead,
  openEditCustomsModal,
}) => {
  if (!exception) return []

  const allActions = [
    {
      code: availableActions.retry,
      id: 'retry',
      label: t('Reintentar'),
      icon: <ArrowsClockwiseIcon size={16} />,
      onClick: onGenerateLabel,
      disabled: generatingLabel,
    },
    {
      code: availableActions.editAddressDestination,
      id: 'editAddressDestination',
      label: t('Editar dirección destino'),
      icon: <PencilSimpleIcon size={16} />,
      onClick: openEditOutboundDestinationAddressModal,
    },
    {
      code: availableActions.markAsResolved,
      id: 'markAsResolved',
      label: t('Marcar como resuelta'),
      icon: <CheckCircleIcon size={16} />,
      onClick: markParcelAlertAsRead,
    },
    {
      code: availableActions.contactCarrier,
      id: 'contactCarrier',
      label: t('Contactar con el transportista'),
      icon: <ContactCarrierIcon size={16} />,
      onClick: openSendEmailModalForContactCarrier,
    },
    {
      code: availableActions.contactUser,
      id: 'contactUser',
      label: t('Contactar con el cliente'),
      icon: <ContactCustomerIcon size={16} />,
      onClick: openSendEmailModalForContactCustomer,
    },
    {
      code: availableActions.editCustomsInfo,
      id: 'editCustomsInfo',
      label: t('Editar información de aduanas'),
      icon: <PencilSimpleIcon size={16} />,
      onClick: openEditCustomsModal,
    },
  ]

  return allActions.filter(action => exception.availableActions.includes(action.code) && action.onClick)
}
